export default class MapLeafletService {
  static getMapConfig() {
    return window.drupalSettings.santeIframeConfig;
  }
}
